import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, PerformanceType } from '@lyearn/lygo-core';

import { FlashCardBlockTypeEnum, NODE_NAME } from './consts';
import plugins from './plugins';

export default class Callout extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        card: {
          default: null,
        },
        type: {
          default: FlashCardBlockTypeEnum.Purple,
        },
      },
      group: 'block',
      isAtom: true,
      parseDOM: [{ tag: 'div.flashCardContainer' }],
      toDOM: () => ['div', { class: 'flashCardContainer' }],
    };
  }

  get name(): string {
    return NODE_NAME;
  }

  get performanceType(): PerformanceType {
    return PerformanceType.BLOCK_BASED;
  }

  plugins = plugins;
}
